import { HomeCard } from "../common/HomeCard"
import HomeAutoRecommendTable from "./HomeAutoRecommendTable"

export const HomeAutoRecommend = () => {
    return (
        <HomeCard title="Automation Recommendation">
            <HomeAutoRecommendTable />
        </HomeCard>
    )
}